import { useState } from "react";

// react-router components
import { Link } from "react-router-dom";

// prop-types is a library for typechecking of props.
import PropTypes from "prop-types";

// @mui material components
import Collapse from "@mui/material/Collapse";
import MuiLink from "@mui/material/Link";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// Material Kit 2 React example components
import NavbarDropdown from "./NavbarDropdown";

function NavbarMobile({ routes, open, openWechatModal }) {
  const [collapse, setCollapse] = useState("");

  const handleSetCollapse = (name) => (collapse === name ? setCollapse(false) : setCollapse(name));

  const renderNavbarItems = routes.map(
    ({ name, icon, collapse: routeCollapses, href, route, collapse: navCollapse }) => (
      <NavbarDropdown
        key={name}
        name={name}
        icon={icon}
        collapseStatus={name === collapse}
        onClick={() => handleSetCollapse(name)}
        href={href}
        route={route}
        collapse={Boolean(navCollapse)}
      >
        <MKBox sx={{ maxHeight: "60vh", overflowY: "auto" }}>
          {routeCollapses &&
            routeCollapses.map((item) => (
              <MKBox key={item.name} px={2}>
                {item.collapse ? (
                  <>
                    <MKTypography
                      display="block"
                      variant="button"
                      fontWeight="bold"
                      textTransform="capitalize"
                      py={1}
                      px={0.5}
                    >
                      {item.name || ""}
                    </MKTypography>
                    {item.collapse.map((el) => {
                      const isWeChat =
                        el.name === "微信客服" ||
                        el.name === "微信" ||
                        el.name === "WeChat" ||
                        el.name === "WeChat Support";

                      const handleClick = (e) => {
                        if (el.disabled) {
                          e.preventDefault();
                          return;
                        }
                        if (isWeChat && typeof openWechatModal === "function") {
                          e.preventDefault();
                          openWechatModal(e);
                        }
                      };

                      return (
                        <MKTypography
                          key={el.name}
                          component={el.route && !isWeChat ? Link : MuiLink}
                          to={el.route && !isWeChat ? el.route : ""}
                          href={el.href && !isWeChat ? el.href : ""}
                          target={undefined}
                          rel={el.href ? "noreferrer" : "noreferrer"}
                          minWidth="11.25rem"
                          display="block"
                          variant="button"
                          color="text"
                          textTransform="capitalize"
                          fontWeight="regular"
                          py={0.625}
                          px={2}
                          sx={({ palette: { grey, dark }, borders: { borderRadius } }) => ({
                            borderRadius: borderRadius.md,
                            cursor: el.disabled ? "not-allowed" : "pointer",
                            transition: "all 300ms linear",
                            opacity: el.disabled ? 0.6 : 1,

                            "&:hover": el.disabled
                              ? {}
                              : {
                                  backgroundColor: grey[200],
                                  color: dark.main,
                                },
                          })}
                          onClick={handleClick}
                        >
                          {el.name || ""}
                        </MKTypography>
                      );
                    })}
                  </>
                ) : (
                  (() => {
                    const isWeChatItem =
                      item.name === "微信客服" ||
                      item.name === "微信" ||
                      item.name === "WeChat" ||
                      item.name === "WeChat Support";

                    const handleClick = (e) => {
                      if (item.disabled) {
                        e.preventDefault();
                        return;
                      }
                      if (isWeChatItem && typeof openWechatModal === "function") {
                        e.preventDefault();
                        openWechatModal(e);
                      }
                    };

                    return (
                      <MKBox
                        key={item.key}
                        display="block"
                        component={item.route && !isWeChatItem ? Link : MuiLink}
                        to={item.route && !isWeChatItem ? item.route : ""}
                        href={item.href && !isWeChatItem ? item.href : ""}
                        target={undefined}
                        rel={item.href ? "noreferrer" : "noreferrer"}
                        sx={({ palette: { grey, dark }, borders: { borderRadius } }) => ({
                          borderRadius: borderRadius.md,
                          cursor: item.disabled ? "not-allowed" : "pointer",
                          transition: "all 300ms linear",
                          py: 1,
                          px: 1.625,
                          opacity: item.disabled ? 0.6 : 1,

                          "&:hover": item.disabled
                            ? {}
                            : {
                                backgroundColor: grey[200],
                                color: dark.main,

                                "& *": {
                                  color: dark.main,
                                },
                              },
                        })}
                        onClick={handleClick}
                      >
                        <MKTypography
                          display="block"
                          variant="button"
                          fontWeight="bold"
                          textTransform="capitalize"
                        >
                          {item.name || ""}
                        </MKTypography>
                        <MKTypography
                          display="block"
                          variant="button"
                          color="text"
                          fontWeight="regular"
                          sx={{ transition: "all 300ms linear" }}
                        >
                          {item.description || ""}
                        </MKTypography>
                      </MKBox>
                    );
                  })()
                )}
              </MKBox>
            ))}
        </MKBox>
      </NavbarDropdown>
    )
  );

  return (
    <Collapse in={Boolean(open)} timeout="auto" unmountOnExit>
      <MKBox width="calc(100% + 1.625rem)" my={2} ml={-2}>
        {renderNavbarItems}
      </MKBox>
    </Collapse>
  );
}

// Typechecking props for the NavbarMobile
NavbarMobile.propTypes = {
  routes: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])).isRequired,
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
  openWechatModal: PropTypes.func,
};

export default NavbarMobile;
